const CONTENT_TYPE = {
  GENRE: 'genre',
  MOOD: 'mood',
  SHOW: 'show',
  STATION: 'station',
  PODCAST: 'podcast',
};

export { CONTENT_TYPE as default };
